// Typelizer digest 8bde407ea23d0c9edc736cf5871836ac
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /learners/schools/:school_id/change_wishlist_items */
  create: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/learners/schools/:school_id/change_wishlist_items', params, options),
    method: 'post',
  }),

  /** GET /learners/schools/:school_id/change_wishlist_items/new */
  new: (
    params: { schoolId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'get'> => ({
    url: buildUrl('/learners/schools/:school_id/change_wishlist_items/new', params, options),
    method: 'get',
  }),
}
